export const SLIDERS_OLYMPIC_TIN_HOC_ICPC_2022 = [
    {
        imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747086981/%E1%BA%A2nh_ch%E1%BB%A5p_m%C3%A0n_h%C3%ACnh_2025-05-13_045546_kevgry.png',
        title: '',
        content: ''
    },
]

export const OLYMPIC_TIN_HOC_ICPC_2022 = [
    {
        imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747088067/481289619_637471348932186_5508431755035269160_n_dyurmo.jpg',
        title: 'OLYMPIC TIN HỌC SINH VIÊN VIỆT NAM LẦN THỨ 33, PROCON VIỆT NAM VÀ KỲ THI LẬP TRÌNH QUỐC TẾ ICPC KHU VỰC CHÂU Á - TP. HỒ CHÍ MINH 2024',
        content:
            '🎉 Vào ngày 9/12/2022, Lễ bế mạc cuộc thi Olympic Tin học Sinh viên Việt Nam lần thứ 31, Procon Việt Nam và Kỳ thi lập trình quốc tế ICPC khu vực Châu Á – TP. Hồ Chí Minh 2022 đã diễn ra tại Trường Đại học Công nghệ Kỹ thuật TP.HCM....',
    }
]

export const AWARDS_OLYMPIC_TIN_HOC_ICPC_2022 = [
    [
        {
            imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747088062/480860921_637471268932194_9068669105249330496_n_uirzje.jpg',
            title: '',
        },
        {
            imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747088060/480983079_637471355598852_4499986637861341580_n_lnwv26.jpg',
            title: '',
        },
    ],
    [
        {
            imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747088057/481262004_637471372265517_6026203959368435811_n_obbdh9.jpg',
            title: '',
        },
        {
            imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747088055/480865598_637471262265528_1256910165904042498_n_gw7l3m.jpg',
            title: '',
        },
    ],
]